import { render, staticRenderFns } from "./AudienceList.vue?vue&type=template&id=19132b54&scoped=true&"
import script from "./AudienceList.vue?vue&type=script&lang=js&"
export * from "./AudienceList.vue?vue&type=script&lang=js&"
import style0 from "./AudienceList.vue?vue&type=style&index=0&id=19132b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19132b54",
  null
  
)

export default component.exports